import React from 'react';

import {Link, IndexLink} from 'react-router';

import Footer from './Footer';

import $ from 'jquery';
import {
  ROUTE_CONTACT,
  ROUTE_FRIENDS, ROUTE_HIRING,
  ROUTE_HOME, ROUTE_INTRODUCTION,
  ROUTE_MEDIA, ROUTE_MEDIA_ENREGISTREMENTS, ROUTE_MEDIA_PHOTOS, ROUTE_MEDIA_VIDEOS,
  ROUTE_PERFORMANCES
} from '../constants'

/*eslint-disable no-script-url*/
class Home extends React.Component {

  componentDidMount() {
    $(".button-collapse").sideNav()
  }

  closeSideNav() {
    $('.button-collapse').sideNav('hide')
  }

  launchPlayer() {
    const { setShowPlayer } = this.props
    setShowPlayer(true)
    $('.modal').modal({ opacity: 0, dismissible: false})
    $('#modalPlaylist').modal('open')
  }

  render() {
    const MediaNav = () => {
      if(this.props.location.pathname.startsWith('/media')) {
        return (
        <ul className="tabs tabs-transparent nav-wrapper white z-depth-5">
        <li className="tab media-tab"><Link activeClassName={'active'} to={ROUTE_MEDIA_ENREGISTREMENTS}>Enregistrements</Link></li>
        <li className="tab media-tab"><Link activeClassName={'active'} to={ROUTE_MEDIA_PHOTOS}>Photos</Link></li>
        <li className="tab media-tab"><Link activeClassName={'active'} to={ROUTE_MEDIA_VIDEOS}>Vidéos</Link></li>
      </ul>
        );
      } else {
        return null;
      }
    }

    return (
      <div>
        <header>
          <div className="navbar-fixed">
            <nav className="white nav-extended" role="navigation">
              <div className="nav-wrapper container">

                <Link to={'/'} id="logo-container" className="brand-logo">
                  <img src="/images/myb_logo.svg" className="myb-logo" alt="Mouv' your Baudet"/>
                  <span>Mouv' your Baudet</span>
                </Link>
                <ul className="right hide-on-med-and-down">
                  <li><IndexLink activeClassName={'active'} className="menu-large" to={ROUTE_HOME}>Accueil</IndexLink></li>
                  <li><Link activeClassName={'active'} className="menu-large" to={ROUTE_INTRODUCTION}>Présentation</Link></li>
                  <li><Link activeClassName={'active'} className="menu-large" to={ROUTE_PERFORMANCES}>Prestations</Link></li>
                  <li><Link activeClassName={'active'} className="menu-large" to={ROUTE_MEDIA}>Médias</Link></li>
                  <li><Link activeClassName={'active'} className="menu-large" to={ROUTE_FRIENDS}>Amis</Link></li>
                  <li><Link activeClassName={'active'} className="menu-large" to={ROUTE_HIRING}>Recrutement</Link></li>
                  <li>
                    <Link activeClassName={'active'} to={ROUTE_CONTACT}
                          className="waves-effect waves-light btn orange-button">Contact
                    </Link>
                  </li>
                </ul>


                <a href="#" data-activates="nav-mobile" className="button-collapse"><i
                  className="material-icons">menu</i></a>
              </div>
            </nav>
          </div>

            <ul id="nav-mobile" className="side-nav">
              <li>
                <div className="userView background-top-drawer">
                  <img src="/images/myb_logo.svg" className="myb-logo" alt="Mouv' your Baudet"/>
                  <span className="white-text">Mouv' your Baudet</span>
                </div>
              </li>
              <li><IndexLink activeClassName={'active'} onClick={this.closeSideNav} to={ROUTE_HOME}><i
                className="material-icons">home</i>Accueil</IndexLink></li>
              <li><Link activeClassName={'active'} onClick={this.closeSideNav} to={ROUTE_INTRODUCTION}><i
                className="material-icons">supervisor_account</i>Présentation</Link></li>
              <li><Link activeClassName={'active'} onClick={this.closeSideNav} to={ROUTE_PERFORMANCES}><i
                className="material-icons">event</i>Prestations</Link></li>
              <li><Link activeClassName={'active'} onClick={this.closeSideNav} to={ROUTE_MEDIA}><i
                className="material-icons">image</i>Médias</Link></li>
              <li><Link activeClassName={'active'} onClick={this.closeSideNav} to={ROUTE_FRIENDS}><i
                className="material-icons">group</i>Amis</Link></li>
              <li><Link activeClassName={'active'} onClick={this.closeSideNav} to={ROUTE_HIRING}><i
                className="material-icons">star</i>Recrutement</Link></li>
              <li><Link activeClassName={'active'} onClick={this.closeSideNav} to={ROUTE_CONTACT}><i
                className="material-icons">mail</i>Contact</Link></li>
            </ul>

            <MediaNav />

        </header>
        <main>
          {this.props.children}
        </main>

      <Footer />

      </div>
    );
  }
}

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/Layout.jsx
 **/